<template>
  <div>
    <filter-controller
      :receive="allProps.receive"
      :receiveAvailable="availableProps.receive"
      :receivePrices="pricesProps.receive"
      :all="allProps.result"
      :prices="pricesProps.result"
      :available="availableProps.result"
      :displayed="displayedFilters"
      :pagination='pagination'
      :loading="allProps.loading"
      :need-sorting='needSorting'
      :need-pricing='needPricing'
      :need-search='needSearch'
      :need-title='needTitle'
      :value="value"
      @input="handleFilter"
      @category-hack='$emit("category-hack", $event)'
      :sortlist='sortlist'
      :label='label'
      :base-url='baseUrl'
      :isStoreCatalog='isStoreCatalog'
      :tabs='tabs'
    />
  </div>
</template>

<script>

import ViewMixin from '@app/Filters/mixins/ViewMixin'

export default {
  mixins: [ViewMixin],
}

</script>
